export const IDENTIFIANT_KEYS = [
  { key: 'dolibarr', letter: 'D', label: 'Dolibarr', icon: 'mdi:briefcase-outline' },
  { key: 'hubspot', letter: 'H', label: 'HubSpot', icon: 'mdi:hubspot' },
  { key: 'drive', letter: 'G', label: 'Google Drive', icon: 'mdi:folder-outline' },
  { key: 'rag', letter: 'R', label: 'RAG', icon: 'mdi:book-search-outline' },
];

export const emptyIdentifiants = () => ({
  dolibarr_id: null,
  dolibarr_code: null,
  dolibarr_url: null,
  hubspot_id: null,
  hubspot_url: null,
  drive_folder_id: null,
  drive_url: null,
  slug: null,
  slug_rag: null,
  slug_rag_effectif: null,
  a_verifier: false,
  rapprochement_statut: 'absent',
});

export const identifiantsOf = (row) => row?.identifiants || emptyIdentifiants();

export const isIdentifiantOn = (ids, key) => {
  if (key === 'dolibarr') return Boolean(ids.dolibarr_id);
  if (key === 'hubspot') return Boolean(ids.hubspot_id);
  if (key === 'drive') return Boolean(ids.drive_folder_id);
  if (key === 'rag') return Boolean(ids.slug_rag || ids.slug_rag_effectif || ids.slug);
  return false;
};

const DOLIBARR_WEB_BASE = (process.env.REACT_APP_DOLIBARR_URL || 'https://dolibarr2.iti-conseil.com').replace(/\/+$/, '');
const HUBSPOT_PORTAL_ID = String(process.env.REACT_APP_HUBSPOT_PORTAL_ID || '2561008').replace(/\D/g, '');

export const hubspotCompanyHref = (hubspotId, hubspotUrl = '') => {
  if (hubspotUrl) return hubspotUrl;
  const id = String(hubspotId || '').trim();
  if (!id) return '';
  if (!HUBSPOT_PORTAL_ID) return '';
  return `https://app.hubspot.com/contacts/${HUBSPOT_PORTAL_ID}/record/0-2/${encodeURIComponent(id)}`;
};

export const identifiantHref = (ids, key) => {
  if (key === 'dolibarr') {
    if (ids.dolibarr_url) return ids.dolibarr_url;
    const id = Number(ids.dolibarr_id);
    if (!Number.isFinite(id) || id <= 0) return '';
    return `${DOLIBARR_WEB_BASE}/comm/card.php?socid=${id}&save_lastsearch_values=1`;
  }
  if (key === 'hubspot') return hubspotCompanyHref(ids.hubspot_id, ids.hubspot_url);
  if (key === 'drive') {
    if (ids.drive_url) return ids.drive_url;
    return ids.drive_folder_id ? `https://drive.google.com/drive/folders/${ids.drive_folder_id}` : '';
  }
  return '';
};

export const identifiantValue = (ids, key) => {
  if (key === 'dolibarr') return ids.dolibarr_code || (ids.dolibarr_id ? `#${ids.dolibarr_id}` : '');
  if (key === 'hubspot') return ids.hubspot_id || '';
  if (key === 'drive') return ids.drive_folder_id || '';
  if (key === 'rag') return ids.slug_rag || ids.slug_rag_effectif || ids.slug || '';
  return '';
};
